import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'

import './sidebar.css'

import logo from './../../../client/assets/logo.png'
import axios from 'axios'
import { useSelector } from 'react-redux'

const SidebarItem = props => {

    const active = props.active ? 'active' : ''

    return (
        <div className="sidebar__item">
            <div className={`sidebar__item-inner ${active}`}>
                <i className={props.icon}></i>
                <span>
                    {props.title}
                </span>
            </div>
        </div>
    )
}

const Sidebar = props => {

    // const activeItem = sidebar_items.findIndex(item => item.route === props.location.pathname)
    const {user} = useSelector((state)=> state.auth)

    const [sellerType, setSellerType] = useState();

    useEffect(()=>{
        axios.get('/seller-type/get').then((res)=> {
            console.log(res.data);
        })
    }, [])

    return (
        <div className='sidebar'>
            <div className="sidebar__logo">
                <Link to={'/'} style={{ textDecoration: 'none', color: '#000' }}>
                    <div className="container">
                        <img src={logo} alt="" />
                        FindNow
                    </div>
                </Link>
            </div>
            <Link to='/admin/dashboard'>
                <SidebarItem
                    title="Dashboard"
                    icon="bx bx-category-alt"
                // active={index === activeItem}
                />
            </Link>
            <Link to='/admin/stores'>
                <SidebarItem
                    title="Stores"
                    icon="bx bx-user-pin"
                // active={index === activeItem}
                />
            </Link>
            <Link to='/admin/get-service-provider'>
                <SidebarItem
                    title="Service Provider"
                    icon="bx bx-user-pin"
                // active={index === activeItem}
                />
            </Link>
            <h5 className='px-5 text-white py-2' style={{background: '#349eff', opacity: '0.5'}}>Stores</h5>
            <Link to='/admin/add-store-products'>
                <SidebarItem
                    title="Add Store Products"
                    icon="bx bx-package"
                // active={index === activeItem}
                />
            </Link>
            <h5 className='px-5 text-white py-2' style={{background: '#349eff', opacity: '0.5'}}>Local Seller</h5>
            <Link to='/admin/add-local-seller-products'>
                <SidebarItem
                    title="Add Local Seller Products"
                    icon="bx bx-package"
                // active={index === activeItem}
                />
            </Link>
            <h5 className='px-5 text-white py-2' style={{background: '#349eff', opacity: '0.5'}}>Tech Store</h5>
            <Link to='/admin/add-tech-products'>
                <SidebarItem
                    title="Add Tech Products"
                    icon="bx bx-package"
                // active={index === activeItem}
                />
            </Link>
            <h5 className='px-5 text-white py-2' style={{background: '#349eff', opacity: '0.5'}}>Pharmacy</h5>
            <Link to='/admin/add-health-products'>
                <SidebarItem
                    title="Add Health Products"
                    icon="bx bx-package"
                // active={index === activeItem}
                />
            </Link>
            {/* {
                sidebar_items.map((item, index) => (
                    <Link to={item.route} key={index}>
                        <SidebarItem
                            title={item.display_name}
                            icon={item.icon}
                        // active={index === activeItem}
                        />
                    </Link>
                ))
            } */}
        </div>
    )
}

export default Sidebar
